import { useState, useRef, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Hook to manage page state for AllQueries page
 * @returns {Object} Page state and handlers
 */
export const useAllQueriesPageState = () => {
  const [searchParams] = useSearchParams();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [queries, setQueries] = useState([]);
  const [allQueries, setAllQueries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [searchQuery, setSearchQuery] = useState(searchParams.get('search') || '');
  const [filters, setFilters] = useState({
    assignedTo: searchParams.get('assignedTo') || '',
  });
  const [assignedFilterOptions, setAssignedFilterOptions] = useState([]);
  const [selectedRegionCard, setSelectedRegionCard] = useState(null);
  const [selectedStatusCard, setSelectedStatusCard] = useState(null);
  const [regionStatusSummary, setRegionStatusSummary] = useState({});
  const [backendCounts, setBackendCounts] = useState(null);
  const [edUsersByRegion, setEdUsersByRegion] = useState({});
  const tableContainerRef = useRef(null);

  const handleChangePage = useCallback((event, newPage) => {
    setPage(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }, []);

  const handleSearchChange = useCallback((value) => {
    setSearchQuery(value);
  }, []);

  const handleFilterChange = useCallback((newFilters) => {
    setFilters(newFilters);
  }, []);

  // Reset to page 0 when search or filters change
  const resetPage = useCallback(() => {
    setPage(0);
  }, []);

  return {
    // State
    page,
    rowsPerPage,
    queries,
    allQueries,
    loading,
    total,
    searchQuery,
    filters,
    assignedFilterOptions,
    selectedRegionCard,
    selectedStatusCard,
    regionStatusSummary,
    backendCounts,
    edUsersByRegion,
    tableContainerRef,
    // Setters
    setPage,
    setRowsPerPage,
    setQueries,
    setAllQueries,
    setLoading,
    setTotal,
    setSearchQuery,
    setFilters,
    setAssignedFilterOptions,
    setSelectedRegionCard,
    setSelectedStatusCard,
    setRegionStatusSummary,
    setBackendCounts,
    setEdUsersByRegion,
    // Handlers
    handleChangePage,
    handleChangeRowsPerPage,
    handleSearchChange,
    handleFilterChange,
    resetPage,
  };
};
